import APIClient from './index';
import _ from 'lodash';

export const fetchVariantsQueue = (data, { signal } = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Queues/Variants?${new URLSearchParams(data).toString()}`, { cancelToken: toCancelToken(signal) })
      .then(response => resolve(response.data))
      .catch(rejectUnlessCancel(reject));
  });
};

export const fetchVariantsFilterOptions = (field, q, { basicUnmatchedOnly, adminUnmatchedOnly, signal } = {}) => {
  return new Promise((resolve, reject) => {
    const params = { field, q, basicUnmatchedOnly: !!basicUnmatchedOnly, adminUnmatchedOnly: !!adminUnmatchedOnly };

    APIClient.get(`Queues/Variants/filterOptions?${new URLSearchParams(params).toString()}`, { cancelToken: toCancelToken(signal) })
      .then(response => resolve(_.get(response, 'data.options', [])))
      .catch(rejectUnlessCancel(reject));
  });
};

export const fetchPinsQueue = (data, { signal } = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Queues/Pins?${new URLSearchParams(data).toString()}`, { cancelToken: toCancelToken(signal) })
      .then(response => resolve(response.data))
      .catch(rejectUnlessCancel(reject));
  });
};

// axios 0.19.2 ignores config.signal — only a CancelToken triggers request.abort(). Bridge the
// caller's AbortSignal to a CancelToken so the XHR is truly aborted, which lets the backend's
// withAbortSignal + knex cancelOnSignal kill the in-flight query. (Remove once axios >= 0.22.)
const toCancelToken = signal => {
  if (!signal) return undefined;
  const source = APIClient.CancelToken.source();
  if (signal.aborted) source.cancel();
  else signal.addEventListener('abort', () => source.cancel(), { once: true });
  return source.token;
};

// Cancellations reject with the axios cancel error so callers can detect them; real failures
// reject with the server's error message.
const rejectUnlessCancel = reject => err => reject(APIClient.isCancel(err) ? err : _.get(err, 'data.error'));
